import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import ReportRunner from '../../components/ReportRunner';

const GeneralReportPage = () => (
  <Layout>
    <p className="rp-breadcrumb">
      Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
      {' >> '}
      <Link to="/rapports" className="bc-link">Reports</Link>
      {' >> '}
      <span className="bc-current">Rapport général</span>
    </p>
    <ReportRunner />
  </Layout>
);

export default GeneralReportPage;
